export default {
    directionPill: {
        long: 'DOLGA',
        short: 'KRATKA',
    },
}
